<template>
  <svg class="vn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false" v-html="body"></svg>
</template>
<script>
import { iconSvg } from '@/utils/vinoIcons';
// <VnIcon name="store" />: an icon from the Vino set; the slanted accent bar follows --icon-accent.
export default {
  name: 'VnIcon',
  props: { name: { type: String, required: true } },
  computed: { body() { return iconSvg(this.name); } },
};
</script>
<style>
.vn-icon { width: 1.25em; height: 1.25em; flex: none; display: block; }
.vn-icon .ic-acc { fill: var(--icon-accent, var(--pink-500)); stroke: none; }
</style>
